import { GOOGLE_SHOP_PRODUCT_STATUS } from "./constants";

export function saveGshopCatalogUpdatedList(data: Record<string, any>): Record<string, any> {
  const { products_statuses } = data;
  const updatedProductStatus = { ...products_statuses };
  if (Object.keys(products_statuses)?.length) {
    updatedProductStatus[GOOGLE_SHOP_PRODUCT_STATUS.ALL.productType] = [];
    Object.keys(products_statuses).forEach((key) => {
      updatedProductStatus[GOOGLE_SHOP_PRODUCT_STATUS.ALL.productType] = updatedProductStatus[
        GOOGLE_SHOP_PRODUCT_STATUS.ALL.productType
      ].concat(products_statuses[key]);
    });
  }
  return updatedProductStatus;
}

const convertSnakeToCamel = (str: string) =>
  str.toLowerCase().replace(/[_][a-z0-9]/g, (group) => group.slice(-1).toUpperCase());

export function transformBEDataToFE(data: any, convertNestedKeys = true) {
  const isDataArrayType = Array.isArray(data);
  const isDataObjectType = data?.constructor === Object;
  const transformedData: any = isDataArrayType ? [] : isDataObjectType ? {} : data;
  if (isDataArrayType) {
    for (const item of data) {
      transformedData.push(transformBEDataToFE(item));
    }
  }
  if (isDataObjectType) {
    for (const key in data) {
      const transformedKey = convertSnakeToCamel(key);
      const value = data[key];
      if (convertNestedKeys && typeof value === "object") {
        transformedData[transformedKey] = transformBEDataToFE(value);
      } else {
        transformedData[transformedKey] = value;
      }
    }
  }
  return transformedData;
}
